import React, { useState } from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import { useTextResources } from '../../../language'
import { Form } from 'semantic-ui-react'
import HotelsDropDown from '../../shared/HotelsDropDown'
import RoomTypesDropDown from '../../shared/RoomTypesDropDown'
import CustomerDropDown from '../../shared/CustomerDropDown'
import ReservationTypesDropDown from '../../shared/ReservationTypesDropDown'
import { GetGuestInHouse } from '../../../api/services/pms'
import ReservationStatusesDropDown from '../../shared/ReservationStatusesDropDown'

const ArrivalListReport = () => {
    const text = useTextResources()
    const [data, setData] = useState([])
    const [resStates, setResStates] = useState([1, 2])

    const onSearchComplete = (data) => {
        setData(data.GuestsInHouse)
    }

    const gridOptions = {
        search: {
            title: text("ArrivalList"),
            description: text("ArrivalList") + " " + text("For") + "...",
            fields: [
                <DatePicker
                    type="basic"
                    label={text("StartDate")}
                    name="StartDate"
                    key="ArrivalDate"
                />,
                <DatePicker
                    type="basic"
                    label={text("EndDate")}
                    name="EndDate"
                    key="ToDate"
                />,
                <Form.Field control={HotelsDropDown} clearable width="4" label={text("Hotel")} key="HotelID" />,
                <Form.Field control={RoomTypesDropDown} clearable width="4" label={text("RoomType")} key="RoomTypeID" />,
                <Form.Field control={CustomerDropDown} clearable width="4" label={text("Agent")} key="AgentID" />,
                <Form.Field control={ReservationTypesDropDown} clearable multiple width="4" label={text("ReservationType")} key="ReservationTypeIDs" />,
                <Form.Field control={ReservationStatusesDropDown} value={resStates} onChange={setResStates} clearable multiple width="4" label={text("ReservationStatus")} key="ReservationStatus" />
            ],
            api: GetGuestInHouse,
            spec: {
                isReportMode: true,
                isShowResult: true,
                PageNumber: 1,
                PageSize: 1000,
                ReservationStatus: 999
            },
            groupSize: 6
        },
        grid: {
            columns: [
                { name: 'GuestFullName', title: text('GuestName') },
                { name: 'ReservationNumber', title: text('Reservation') },
                { name: 'FolioID', title: text('Folio') }
            ]
        }
    }
    return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} data={data} />)
}

export default ArrivalListReport